/**
 * Pages
 */

export {ServiceCampaignsOverview} from './pages/ServiceCampaigns/components/ServiceCampaignsOverview';
export {ServiceCampaignDetail} from './pages/ServiceCampaignDetail/ServiceCampaignDetail';
